<template>
  <div class="outer-page">
    <x-table
      :no-data-text="
        CA('distributionCenter_check') ? '暂无数据' : '暂无数据查看权限'
      "
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @loadEnter="loadEnter"
      @loadExpend="loadExpend"
      @search="search"
      @add="add"
      @page-change="pageChange"
      @page-size-change="pageSizeChange"
    ></x-table>
    <Modal
      v-model="modal.show"
      :title="modal.title"
      :width="500"
      @on-visible-change="modalChange"
    >
      <Form :label-width="140" ref="form" :model="form" :rules="rules">
        <FormItem label="集散点名称" prop="serviceName">
          <Input
            v-model="form.serviceName"
            placeholder="请输入集散点名称"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="业务范围" prop="businessScope">
          <Input
            clearable
            placeholder="请输入业务范围"
            v-model="form.businessScope"
          ></Input>
        </FormItem>
        <FormItem label="联系人" prop="name">
          <Input
            clearable
            placeholder="请输入联系人"
            v-model="form.name"
          ></Input>
        </FormItem>
        <FormItem label="联系电话" prop="tel">
          <Input
            clearable
            placeholder="请输入联系电话"
            v-model="form.tel"
          ></Input>
        </FormItem>
        <FormItem label="社会统一信用代码" prop="creditCode">
          <Input
            clearable
            placeholder="请输入社会统一信用代码"
            v-model="form.creditCode"
          ></Input>
        </FormItem>
        <FormItem label="企业类型" prop="enterpriseType">
          <Select
            clearable
            placeholder="请输入企业类型"
            v-model="form.enterpriseType"
          >
            <Option
              v-for="(item, index) in companyData"
              :key="index"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="营业期限" prop="businessTerm">
          <Input
            clearable
            placeholder="请输入营业期限"
            v-model="form.businessTerm"
          ></Input>
        </FormItem>
        <FormItem label="所属行业" prop="industry">
          <Input
            v-model="form.industry"
            placeholder="请输入所属行业"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="省市区编码" prop="region">
          <Cascader
            :data="area"
            v-model="form.region"
            :load-data="loadData"
          ></Cascader>
        </FormItem>
        <FormItem label="联系地址" prop="serviceAddress">
          <Input
            clearable
            placeholder="请输入联系地址"
            v-model="form.serviceAddress"
          ></Input>
        </FormItem>
        <FormItem label="位置" prop="thirdLongLat">
          <Input
            v-model="form.thirdLongLat"
            disabled
            placeholder="点击右侧图标选择位置"
          >
            <span
              slot="append"
              class="iconfont"
              @click="mapModalShow"
              style="cursor: pointer"
              >&#xe648;</span
            >
          </Input>
        </FormItem>
      </Form>
      <p slot="footer" style="text-align: center">
        <Button type="primary" @click="submit">提交</Button>
        <Button @click="() => (this.modal.show = false)">取消</Button>
      </p>
    </Modal>

    <Modal v-model="mapModel" title="选择位置" fullscreen>
      <search-map
        v-if="mapModel"
        :currentData="currentData"
        @back-location="dealMapData"
      ></search-map>
      <p slot="footer" style="text-align: center">
        <Button type="primary" @click="() => (mapModel = false)">提交</Button>
        <Button @click="() => (mapModel = false)">取消</Button>
      </p>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchMap from "@/components/searchMap";
import CU from "@/common/util";

export default {
  name: "",
  components: { searchMap },
  data() {
    return {
      table: {
        columns: [
          {
            title: "名称",
            minWidth: 100,
            key: "serviceName",
          },
          {
            title: "业务范围",
            minWidth: 100,
            tooltip: true,
            key: "businessScope",
          },
          {
            title: "企业类型",
            width: 140,
            align: "center",
            key: "enterpriseTypeName",
          },
          {
            title: "统一社会信用代码",
            width: 150,
            key: "creditCode",
          },
          {
            title: "所属行业",
            width: 140,
            align: "center",
            key: "industry",
          },
          {
            title: "联系人",
            minWidth: 100,
            key: "name",
          },
          {
            title: "联系电话",
            minWidth: 130,
            key: "tel",
          },
          {
            title: "服务地址",
            minWidth: 100,
            key: "serviceAddress",
          },
          {
            title: "操作",
            width: 150,
            render: (h, { row }) => {
              return (
                <div>
                  {this.CA("distributionCenter_edit") && (
                    <a
                      style="margin-right:10px"
                      on-click={() => this.edit(row)}
                    >
                      编辑
                    </a>
                  )}
                  {this.CA("distributionCenter_del") && (
                    <Poptip
                      confirm
                      transfer
                      title="确定删除吗?"
                      on-on-ok={() => this.delete(row.id)}
                    >
                      <a>删除</a>
                    </Poptip>
                  )}
                </div>
              );
            },
          },
        ],
        data: [],
        loading: false,
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      search_data: {},
      modal: {
        show: false,
        title: "",
        submitLoading: false,
      },
      form: {
        id: "",
        businessScope: "",
        name: "",
        tel: "",
        serviceAddress: "",
        type: 2,
        category: "",
        thirdLongLat: "",
        serviceName: "",
        //社会统一信用代码
        creditCode: "",
        //企业类型
        enterpriseType: "",
        //营业期限
        businessTerm: "",
        //所属行业
        industry: "",
        //省市区编码
        regionCode: "",
        region: [],
      },
      rules: {
        serviceName: [{ required: true, message: "请填写集散点名称" }],
        businessScope: [{ required: true, message: "请填写业务范围" }],
        name: [{ required: true, message: "请填写联系人" }],
        tel: [
          { required: true, message: "请填写联系电话" },
          {
            validator(rule, value, callback) {
              if (!/^1[3|4|5|7|8|9][0-9]{9}$/.test(value)) {
                callback(rule.message);
                return;
              }
              callback();
            },
            message: "手机号格式不正确",
            trigger: "change",
          },
        ],
        serviceAddress: [{ required: true, message: "请填写组织地址" }],
        thirdLongLat: [{ required: true, message: "请选择位置" }],
        creditCode: [{ required: true, message: "请输入社会统一信用代码" }],
        enterpriseType: [{ required: true, message: "请选择企业类型" }],
        businessTerm: [{ required: true, message: "请输入营业期限" }],
        industry: [{ required: true, message: "请输入所属行业" }],
        region: [{ required: true, type: "array", message: "请选择省市区" }],
      },
      mapModel: false,
      currentData: null,
      companyData: [],
      area: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    config() {
      let config = {
        filter: {
          add: {
            addBtnName: "新增集散点",
            ca: "distributionCenter_add",
          },
          width: 200,
          loadModel:{
            url:'https://castoff.hogdata.cn/app/社会化组织和集散点.xlsx'
          },
          loadEnter: {
            loadName: "导入",
            ca: "terminalEquipment_import",
          },
          loadExpend:{
            loadExpendName: "导出",
          },
          filterBox: [
            {
              conditionName: "业务范围",
              component: "input",
              field: "businessScope",
              defaultValue: "",
            },
          ],
        },
        page: { ...this.page },
      };
      return config;
    },
  },
  methods: {
    //导入
    loadEnter() {
      let input = document.createElement("input");
      input.type = "file";
      input.onchange = (e) => {
        if (!input.files || input.length === 0) return;
        let formdata = new FormData();
        formdata.append("file", input.files[0]);
        formdata.append("userId", localStorage.getItem("userId"));
        formdata.append("companyNo", localStorage.getItem("companyNo"));
        formdata.append("type", 2);
        this.$post(this.$api.SOCIAL_MANAGE.UPLOAD, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(() => {
          this.$Message.success('导入成功')
          this.getList();
        });
      };
      input.click();
    },
    mapModalShow() {
      this.currentData = this.form.thirdLongLat;
      this.mapModel = true;
    },
    dealMapData(positionData) {
      this.form.thirdLongLat = positionData.thirdLongLat;
    },
    getList() {
      if (!this.CA("distributionCenter_check")) return;
      this.table.loading = true;
      this.$post(this.$api.SOCIAL_MANAGE.LIST, {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        type: 2,
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    //企业类型
    getCompanyCategory() {
      this.$post(this.$api.SYS_CATEGORY.LIST, {
        pid: "203",
      }).then((res) => {
        this.companyData = res.list;
      });
    },
    search(value) {
      this.search_data = value;
      this.getList();
    },
    add() {
      this.modal = {
        show: true,
        title: "新增集散点",
        submitLoading: false,
      };
    },
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key];
      }
      this.form.region = row.regionCode.split(",");
      this.modal = {
        show: true,
        title: "编辑集散点",
        submitLoading: false,
      };
    },
    delete(id) {
      this.$post(this.$api.SOCIAL_MANAGE.DELETE, {
        id,
      }).then(() => {
        this.$Message.success("删除成功！");
        this.getList();
      });
    },
    submit() {
      this.$refs.form.validate().then((res) => {
        if (!res) return;
        let params = { ...this.form };
        params.category = this.user.category + 1;
        params.regionCode = this.form.region.join(",");
        delete params.region;
        let url;
        params.id
          ? (url = this.$api.SOCIAL_MANAGE.UPDATE)
          : (url = this.$api.SOCIAL_MANAGE.ADD);
        this.$post(url, params).then(() => {
          this.$Message.success(params.id ? "修改成功！" : "添加成功！");
          this.getList();
          this.modal.show = false;
          this.modal.submitLoading = false;
        });
      });
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getList()
    },
    modalChange(visible) {
      if (visible) return;
      this.form = {
        id: "",
        businessScope: "",
        name: "",
        tel: "",
        serviceAddress: "",
        type: 2,
        category: "",
        thirdLongLat: "",
        serviceName: "",
        //社会统一信用代码
        creditCode: "",
        //企业类型
        enterpriseType: "",
        //营业期限
        businessTerm: "",
        //所属行业
        industry: "",
        //省市区编码
        regionCode: "",
        region: [],
      };
      this.$refs.form.resetFields();
    },
    getArea() {
      this.$post(this.$api.AREA_MANAGE.LIST, {
        parentId: "100000",
      }).then((res) => {
        this.area = res.map((item) => {
          let obj = {
            ...item,
            value: item.id,
            label: item.name,
            children: [],
            loading: false,
          };
          return obj;
        });
      });
    },
    loadData(item, callback) {
      item.loading = true;
      this.$post(this.$api.AREA_MANAGE.LIST, {
        parentId: item.id,
      })
        .then((res) => {
          res.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
            if (item.hasChild == "true") {
              item.children = [];
              item.loading = false;
            }
          });
          item.children = res;
          callback();
        })
        .finally(() => {
          item.loading = false;
        });
    },
    loadExpend(){
      let columns = this.table.columns.map((item)=>item.title)
      columns.pop();
      let data = this.table.data.map((row)=>{
        let rowData = this.table.columns.map((column)=>{
          return row[column.key];
        })
        return rowData
      })
      CU.exportExcel(columns, data, "集散点信息");
    }
  },
  mounted() {
    this.getList();
    this.getCompanyCategory();
    this.getArea();
  },
};
</script>

<style lang="less" scoped>
.outer-page {
  width: 100%;
  height: 100%;
}
</style>